import React, { Component, Fragment } from "react"
import { withStyles } from "@material-ui/core/styles"
import widthWidth from "@material-ui/core/withWidth"
import { compose } from "recompose"
import { connect } from "react-redux"
import styles from "./styles"
import Typography from "@material-ui/core/Typography"
import HelpIcon from "@material-ui/icons/Help"
import update from "immutability-helper"
import { Chip, Hidden } from "@material-ui/core"
import CancelIcon from "@material-ui/icons/Cancel"
import {
  isEmpty,
  filter,
  intersectionWith,
  isEqual,
  compact,
  sortBy,
  uniqBy,
} from "lodash"
import InfiniteScroll from "react-infinite-scroll-component"
import CrewCard from "../../components/CrewCard"
import MainAppBar from "../../components/MainAppBar"
import CrewMamaAppBarComponent from "../../components/CrewmamaAppBar"
import LoadingIndicator from "../../components/LoadingIndicator"
import AddIcon from "@material-ui/icons/Add"
import { getCurrentHost } from "../../utils/getHost"

import {
  toggleProfileDialog,
  getUserByReel,
  toggleCreateUserDialog,
} from "../../actions/users"

import {
  toggleMessageDrawer,
  setActiveChatter,
  getMessages,
} from "../../actions/message-drawer"
import {
  listCrew,
  searchCrew,
  sortCrew,
  removeFromCompany,
  toggleReferCrewDialog,
  getCrewLength,
  loadingCrew,
  clearCrew,
  clearCrewFromChip,
  loadingCrewFromChip,
} from "../../actions/crew"
import {
  addRating,
  getAds,
  getSocialNetworks,
  getLocationByInput,
} from "../../actions/misc"

import { lengthCrew } from "../../actions/crew"
import { toggleShootDialog, setShootDialogCrew } from "../../actions/shoots"
import { openSnackBar } from "../../actions/snack-bar"
import CreateUserDialog from "../../components/CreateUserDialog"
import Fab from "@material-ui/core/Fab"
import { pluralize } from "inflection"
import { openAlert } from "../../actions/alert"
import { toggleBookingDialog } from "../../actions/companies"
import { hiddenLoginModal } from "../../actions/authentication"
import { convertToState } from "../../lib/states.js"

import Legend from "../../components/Legend"
import AdCard from "../../components/AdCard"
import TabBar from "../../components/TabBar"
import CrewActionBar from "../../components/CrewActionBar/index"

import {
  getParentChildRoles,
  getParentChildRolesNoCount,
} from "../../actions/roles"
import CrewExport from "../../components/CrewExport/index"
let companyName =
  // window.location.host.indexOf("adesk") === -1 ? "CREWMAMA" : "ADESK"
  "CREWMAMA"
const loadPage = params => {
  switch (params.path) {
    case "/setup":
      return 0
    case "/inventory":
      return 1
    case "/checkout":
      return 2
    default:
      return 0
  }
}

class Crew extends Component {
  constructor(props) {
    super(props)
    this.myRef = React.createRef()
    this.state = {
      selectedPointer: "",
      chipCount: 0,
      chipActive: false,
      hasMoreItems: true,
      searchTerm: "",
      value: 0,
      selectedUser: "",
      selectedRole: "",
      selectedLocation: "",
      selectedEquipment: "",
      currentPage: 1,
      activeSort: "ranking",
      desc: true,
      filters: {
        elite: c => c.badges.find(b => b.id === 1),
        go_to_team: c => c.organization === "Go To Team",
        labor_only: {
          labor_only: true,
        },
      },
      activeFilters: [],
      sorts: [
        {
          name: "ranking",
          orderBy: [
            ["master_rating", o => o.ratings.length, "last_name"],
            [() => (this.state.desc ? "desc" : "asc"), "desc", "asc"],
          ],
        },
        {
          name: "rate",
          orderBy: [
            [
              o =>
                o.roles.find(n => n.name === this.state.selectedRole).rate || 0,
              "last_name",
            ],
            [() => (this.state.desc ? "desc" : "asc"), "asc"],
          ],
        },
      ],
      showLegend: false,
      showAddLegend: false,
      postsPerPage: [25],
      getCrewLength: "",
      crewLength: null,
      cardPerPage: 100,
      reel_scout_id: 70803,
      currentPagee: 1,
    }
  }
  async componentWillUnmount() {
    if (this.props.crew.crew.length > 0) {
      // this.props.dispatch(loadingCrewFromChip())
      await this.props.dispatch(clearCrew())
    }
    if (
      this.state.selectedEquipment !== "" ||
      this.state.selectedLocation !== "" ||
      this.state.selectedRole !== "" ||
      this.state.selectedUser !== ""
    ) {
      this.props.dispatch(loadingCrewFromChip())

      this.props.dispatch(clearCrewFromChip())
    }
    // this.props.dispatch(loadingCrewFromChip())
  }

  async queryStringToJSON(queryString) {
    if (queryString.indexOf("?") > -1) {
      queryString = queryString.split("?")[1]
    }
    var pairs = queryString.split("&")
    var result = {}
    pairs.forEach(function(pair) {
      pair = pair.split("=")
      result[pair[0]] = decodeURIComponent(pair[1] || "")
    })
    return result
  }

  async componentWillMount() {
    if (this.props.crew.crew.length > 0) {
      this.setState(
        update(this.state, {
          currentPage: {
            $set: this.state.currentPage + 1,
          },
        })
      )
    }
    if (this.props.crew.crewlength.length === 0) {
      this.props.dispatch(getCrewLength()).then(async res => {
        let data = res.map(a => a.usersCount)
        await this.setState({ crewLength: data })
        this.props.dispatch(lengthCrew(data[0]))
        if (this.props.crew.crew.length > 0) {
          this.props.dispatch(loadingCrew())
        }
      })
    }

    if (
      this.props.history.location.hasOwnProperty("state") &&
      this.props.history.location.state &&
      this.props.history.location.state.hasOwnProperty("actionBarState")
    ) {
      this.setInitialActionbarState(
        this.props.history.location.state.actionBarState
      )
    }
  }

  async componentDidMount() {
    // var test = store.getState()
    // var data = test.users.crewModal
    this.myRef.current.scrollTo(0, 0)
    let arr = [false, false, false, false]
    let bool = true

    if (window.location.search === "") {
      await this.props.dispatch(listCrew(this.state.currentPagee)).then(res => {
        this.props.dispatch(loadingCrew)
      })
    }
    await Promise.all([
      this.props.dispatch(getSocialNetworks()),
      this.props.dispatch(getParentChildRolesNoCount()),
      //this.props.dispatch(getParentChildRoles()),
    ])

    if (
      !isEmpty(this.props.location.search) &&
      getCurrentHost() === "crewmama"
    ) {
      let searchParams = await this.queryStringToJSON(
        this.props.location.search
      )
      let stuff = null
      Object.keys(searchParams).forEach(key => {
        if (key === "Role") {
          stuff = this.props.childParentRoles.parents.find(
            n => n.id == searchParams[key]
          )
        } else {
          stuff = JSON.parse(searchParams[key])
        }
        const newState = stuff ? stuff : searchParams[key]
        this.setState(
          update(this.state, {
            [`selected${key}`]: {
              $set: newState,
            },
          })
        )
      })
    }

    this.props.dispatch(getAds()).then(res => {
      const s = a => {
        for (let i = a.length - 1; i > 0; i--) {
          const j = Math.floor(Math.random() * (i + 1))
          ;[a[i], a[j]] = [a[j], a[i]]
        }
        return a
      }
      this.setState({ ads: s(res) })
    })
    arr.forEach(x => (bool = x ? bool : false))

    if (!bool && !this.props.makeSearches) {
      setTimeout(() => {
        this.loadCrew()
      }, 500)
    }

    // this.props.makeSearches comes from Routes.js
    var reel = "reel"
    var book = "book"
    if (this.props.makeSearches) {
      if (
        window.location.pathname.includes(reel) &&
        window.location.pathname.includes(book)
      ) {
        setTimeout(() => {
          this.loadCrew()
        }, 500)
        let reel_scout_id = window.location.pathname
        reel_scout_id = reel_scout_id.match(/\d+/g).map(Number)
        await this.props.dispatch(getUserByReel(reel_scout_id))
        var data = this.props.crewModal
        if (this.props.setModal === 1) {
          this.props.dispatch(toggleBookingDialog(true, data))
        }
      } else {
        let parts = window.location.pathname
          .substring(1)
          .split("/")
          .map(x => x.replace(/\+/g, "_"))
        if (parts.length > 2) {
          if (parts[0] === "l") {
            const city = parts[1]
            let state = parts[2],
              abbr = state
            let newState = convertToState(state)
            if (newState[0] && newState[0].name) {
              state = newState[0].name
            }

            this.props
              .dispatch(
                searchCrew({
                  locations: {
                    city,
                    state,
                  },
                  currentPage: this.state.currentPage,
                })
              )
              .then(res => {
                this.setState({
                  currentPage: 1,
                  selectedLocation: {
                    city,
                    state,
                    locations: city.replace("_", " ") + ", " + state,
                  },
                })
              })
          } else {
            const city = parts[1],
              name = parts[0]
            let state = parts[2],
              abbr = state
            let newState = convertToState(state)

            if (newState[0] && newState[0].name) {
              state = newState[0].name
            }
            this.props
              .dispatch(
                searchCrew({
                  locations: {
                    city,
                    state,
                  },
                  roles: {
                    name,
                  },
                  currentPage: this.state.currentPage,
                })
              )
              .then(res => {
                this.setState({
                  currentPage: 1,
                  selectedRole: {
                    name: name.replace("_", " "),
                  },
                  selectedLocation: {
                    city,
                    state,
                    locations: city.replace("_", " ") + ", " + state,
                  },
                })
              })
          }
        } else {
          const name = parts[0]
          this.props
            .dispatch(
              searchCrew({
                roles: {
                  name,
                },
                currentPage: this.state.currentPage,
              })
            )
            .then(res => {
              this.setState({
                currentPage: 1,
                selectedRole: {
                  name: name.replace("_", " "),
                },
              })
            })
        }
        this.props.dispatch({
          type: "PAGE_TITLE",
          payload: `Crew Mama | Film, Video, Production & Camera Crew Directory | Search Crew Profile Listing`,
        })
      }
    }
  }
  componentDidUpdate(p) {
    if (this.state.value !== loadPage(this.props.match)) {
      this.setState({ value: loadPage(this.props.match) })
    }

    if (
      p.users[0] === "LOADING..." &&
      this.props.users.length > 1 &&
      this.props.match &&
      this.props.match.params &&
      this.props.match.params.user_id &&
      Number(this.props.match.params.user_id)
    ) {
      const id = Number(this.props.match.params.user_id)
      let user = this.props.users.filter(x => x.id === id)[0]
      if (user && user.id) {
        this.props.dispatch(toggleProfileDialog(true, { id }))
      }
    }
  }

  setInitialActionbarState = theState => {
    switch (theState.type) {
      case "AutoComplete":
        this.onAutoCompleteChange(theState.data.value, theState.data.name)
        break
      case "FilterMenuItem":
        this.handleFilterMenuItemClick(theState.data)
        break
      default:
        return false
    }
    this.props.history.replace("/", {})
  }

  handleChange = name => event => {
    this.setState({
      [name]: event.target.value,
    })
  }

  handleChange = (event, value) => {
    if (value) {
      this.setState({ value })
    }
  }
  handleChangeSwitch = name => event => {
    this.setState({ [name]: event.target.checked })
  }
  openMessageDrawer = crew => {
    this.props.dispatch(setActiveChatter(crew))
    this.props.dispatch(getMessages(crew.id, this.props.activeCompany))
    this.props.dispatch(toggleMessageDrawer(true))
  }
  onAutoCompleteChange = async (val, name) => {
    await this.props.dispatch(clearCrewFromChip())
    // await this.props.dispatch(clearCrewSearchLength())
    let stuff = null

    if (name === "Role") {
      // let stuffs = this.props.childParentRoles.children.find(n => n.id === 23)

      stuff = val

      this.setState(
        update(this.state, { selectedPointer: { $set: "children" } })
      )
    } else if (name === "Category") {
      stuff = this.props.childParentRoles.parents.find(n => n.id === val)

      this.setState(update(this.state, { selectedPointer: { $set: "parent" } }))
    } else {
      stuff = this.props[pluralize(name).toLowerCase()].find(n => n.id === val)
    }
    const newState = stuff ? stuff : val

    if (name === "Role" || name === "Category") {
      this.setState(
        update(this.state, {
          [`selectedRole`]: {
            $set: newState,
          },
          searchMenuAnchorEl: {
            $set: null,
          },
        })
      )
    } else {
      this.setState(
        update(this.state, {
          [`selected${name}`]: {
            $set: newState,
          },
          searchMenuAnchorEl: {
            $set: null,
          },
        })
      )
    }

    setTimeout(() => {
      this.loadCrew()
    }, 100)
  }
  loadCrew = async () => {
    let query = {}
    this.setState(
      update(this.state, {
        activeSort: {
          $set: "ranking",
        },
        desc: {
          $set: true,
        },
      })
    )
    if (this.state.selectedUser) {
      const { full_name } = this.state.selectedUser
      query.users = { full_name }
    }
    if (this.state.selectedRole) {
      const { name } = this.state.selectedRole
      query.roles = { roleNames: [name] }
      // let child = []
      // if (this.state.selectedPointer === "children") {

      //   let newChild = this.props.childParentRoles.children.find(y => y.id === id)

      //   child.push(newChild)
      // } else {

      //   child = this.props.childParentRoles.connections
      //     .map(
      //       x =>
      //         x.parent_role_id === id
      //           ? this.props.childParentRoles.children.find(
      //             y => x.child_role_id === y.id
      //           )
      //           : null
      //     )
      //     .filter(el => el != null)
      // }
      // let roleNames = []
      // child && !isEmpty(compact(child)) && child.map(c => roleNames.push(c.name))

      // query.roles = { roleNames: roleNames }
    }
    if (this.state.selectedLocation) {
      let opts = {}
      if (this.state.selectedLocation) {
        var location = this.state.selectedLocation.locations
        var data = location.split(",")
        let state = data[1]
        state = state.trim()
        let city = data[0]
        opts = { city, state }
      }
      query.locations = { ...opts }
    }
    if (this.state.selectedEquipment) {
      const { name } = this.state.selectedEquipment
      query.equipment = { name }
    }
    if (isEmpty(query)) {
      if (this.props.crew.crew.length === 0) {
        this.setState({ currentPage: 1 })
        await this.props
          .dispatch(listCrew(this.state.currentPage))
          .then(res => {
            this.props.dispatch(loadingCrew)
            this.setState({ chipActive: false })
          })
      }
    } else {
      this.setState({ currentPage: 1 })
      const currentPage = this.state.currentPage
      query.currentPage = { currentPage }
      this.props.dispatch(loadingCrewFromChip())
      this.setState({ chipActive: true })
      this.props.dispatch(clearCrewFromChip())
      this.props.dispatch(searchCrew(query))

      // this.props.dispatch(searchCrew(query)).then(res => {
      //   this.setState({
      //     currentPage: 1,
      //   })
      // })
    }
  }
  resetControls = () => {
    this.setState(
      update(this.state, {
        activeSort: {
          $set: "ranking",
        },
        desc: {
          $set: true,
        },
        currentPage: {
          $set: 1,
        },
        selectedUser: {
          $set: "",
        },
        selectedRole: {
          $set: "",
        },
        selectedLocation: {
          $set: "",
        },
      })
    )
  }
  onDelete = async name => {
    await this.setState(
      update(this.state, {
        [`selected${name}`]: {
          $set: "",
        },
        // chipActive: {
        //   $set: this.state.chipCount - 1,
        // },
      })
    )
    if (
      this.state.selectedEquipment === "" &&
      this.state.selectedLocation === "" &&
      this.state.selectedUser === "" &&
      this.state.selectedRole === ""
    ) {
      this.props.dispatch(clearCrewFromChip())
      this.props.dispatch(loadingCrewFromChip())
    }
    await setTimeout(() => {
      this.loadCrew()
    }, 100)
  }
  chipHanlde = () => {}
  // loadMore = () => {
  //   this.setState(
  //     update(this.state, {
  //       currentPage: {
  //         $set: this.state.currentPage + 1,
  //       },
  //     })
  //   )
  //   this.props.dispatch(listCrew(this.state.currentPage))
  // }

  fetchMoreItems = async () => {
    if (
      this.state.selectedEquipment !== "" ||
      this.state.selectedLocation !== "" ||
      this.state.selectedRole !== "" ||
      this.state.selectedUser !== ""
    ) {
      var query = {}
      //// INPUT VALUES IN SEARCH
      if (this.state.selectedUser) {
        const { full_name } = this.state.selectedUser
        query.users = { full_name }
      }
      if (this.state.selectedRole) {
        const { name } = this.state.selectedRole
        query.roles = { name }
      }
      if (this.state.selectedLocation) {
        let opts = {}
        if (this.state.selectedLocation) {
          var location = this.state.selectedLocation.locations
          var data = location.split(",")
          let state = data[1].trim()
          let city = data[0].trim()
          opts = { city, state }
        }
        query.locations = { ...opts }
      }
      if (this.state.selectedEquipment) {
        const { name } = this.state.selectedEquipment
        query.equipment = { name }
      }
      this.setState({ currentPage: this.state.currentPage + 1 })
      const currentPage = this.state.currentPage
      query.currentPage = { currentPage }

      if (this.props.crew.crew.length < this.props.crew.searchcrewLength) {
        await this.props.dispatch(searchCrew(query))
      }
    } else {
      this.setState({ currentPage: this.state.currentPage + 1 })
      if (this.props.crew.crew.length < this.props.crew.searchcrewLength) {
        await this.props.dispatch(listCrew(this.state.currentPage))
      }
    }
  }

  changeSortBy = sortBy => {
    let desc
    if (this.state.activeSort !== sortBy) {
      desc = true
    } else {
      desc = !this.state.desc
    }
    this.setState(
      update(this.state, {
        activeSort: {
          $set: sortBy,
        },
        desc: {
          $set: desc,
        },
      })
    )
    setTimeout(() => {
      this.doSortBy()
    }, 150)
  }
  doSortBy = () => {
    const sort = this.state.sorts
      .find(sort => {
        // find sort from list based on active sort
        return sort.name === this.state.activeSort
      })
      .orderBy.map((order, index) => {
        // loop over each set of orderBy arrays
        // if we are on the second index we need to loop over to trigger callbacks
        // other wise return the current order array
        return index === 1
          ? order.map(n => {
              // loop over each iteratee order to see if it's a function
              // if the type of this iteratee order is a function, call it
              // other wise return the iteratee order
              return typeof n === "function" ? n() : n
            })
          : order
      })
    this.props.dispatch(sortCrew(this.props.crew.crew, sort)).then(() => {
      this.setState(
        update(this.state, {
          currentPage: {
            $set: 1,
          },
        })
      )
    })
  }

  ratingChanged = (value, crew) => {
    let existingRating
    if (this.props.activeCompany) {
      existingRating = crew.ratings.find(
        r => r.company_id === this.props.activeCompany
      )
    } else {
      existingRating = crew.ratings.find(
        r => r.creator_id === this.props.authenticatedUser.id
      )
    }
    let ratingId = undefined
    if (existingRating) {
      ratingId = existingRating.id
    }
    this.props.dispatch(
      addRating(
        value,
        ratingId,
        crew.id,
        this.props.authentication.authenticatedUser,
        this.props.activeCompany
      )
    )
  }
  removeFromCompany = crewMember => {
    this.props
      .dispatch(
        openAlert({
          title: "Are you sure?",
          body:
            "This will remove this user from your company and you may not be able to see them again, are you sure?",
        })
      )
      .then(() => {
        this.props
          .dispatch(removeFromCompany(crewMember.id, this.props.activeCompany))
          .then(() => {
            this.props.dispatch(
              openSnackBar({
                message: "User removed from this organization",
              })
            )
          })
          .catch(() => {
            this.props.dispatch(
              openSnackBar({
                message:
                  "There was an error removing this user from this organization",
              })
            )
          })
      })
      .catch(() => {})
  }
  handleOpenMenu = (e, name) => {
    this.setState({ [`${name}MenuAnchorEl`]: e.currentTarget })
  }
  handleCloseMenu = name => {
    this.setState({ [`${name}MenuAnchorEl`]: null })
  }
  handleFilterMenuItemClick = filter => {
    const currentIndex = this.state.activeFilters.indexOf(filter)
    let newFilters = this.state.activeFilters
    if (currentIndex > -1) {
      newFilters.splice(currentIndex, 1)
    } else {
      newFilters = [...newFilters, filter]
    }
    this.setState(
      update(this.state, {
        currentPage: {
          $set: 1,
        },
        activeFilters: {
          $set: newFilters,
        },
      })
    )
  }

  getFilteredCrew = () => {
    const filters = this.state.activeFilters.map(f => this.state.filters[f])
    if (filters.length > 0) {
      return intersectionWith(
        ...filters.map(f => filter(this.props.crew.crew, f)),
        isEqual
      )
    } else {
      return this.props.crew.crew
    }
  }

  handleSortMenuItemClicked = sort => {
    this.handleCloseMenu("sort")
    this.changeSortBy(sort)
  }

  referCrewMember = () => {
    hiddenLoginModal()
      .then(res => {
        this.props.dispatch(toggleReferCrewDialog(true))
      })
      .catch(err => console.log({ err }))
  }
  handleActionBarChange = change => {
    switch (change.type) {
      case "AutoComplete":
        this.onAutoCompleteChange(change.data.value, change.data.name)
        break
      case "FilterMenuItem":
        this.handleFilterMenuItemClick(change.data)
        break
      case "SortMenuItem":
        this.handleSortMenuItemClicked(change.data)
        break
      default:
        return false
    }
  }
  //
  render() {
    const filteredCrew = this.getFilteredCrew()
    const sortCrew = [
      ...filteredCrew.filter(
        item => item.organization === "Go To Team" && !isEmpty(item.badges)
      ),
      ...filteredCrew.filter(
        item => item.organization === "Go To Team" && isEmpty(item.badges)
      ),
      ...filteredCrew.filter(
        item => item.organization !== "Go To Team" && !isEmpty(item.badges)
      ),
      ...filteredCrew.filter(
        item => item.organization !== "Go To Team" && isEmpty(item.badges)
      ),
    ]

    const pagedCrew = sortCrew

    let adFrequency = 6,
      adIndex = 0
    if (filteredCrew.length >= 20) {
      adFrequency = 10
    }

    const { accessLevel } = this.props
    return (
      <Fragment>
        <div ref={this.myRef} />
        {getCurrentHost() === "crewmama" ? (
          <CrewMamaAppBarComponent history={this.props.history} />
        ) : (
          <Fragment>
            <MainAppBar />
            <TabBar history={this.props.history} />
          </Fragment>
        )}

        <div className={`page ${this.props.classes.pageBackground}`}>
          <CrewActionBar
            history={this.props.history}
            onChange={this.handleActionBarChange}
            activeFilters={this.state.activeFilters}
            sortDescending={this.state.desc}
            prop={this.props}
          />
          {this.props.hasOwnProperty("authentication") &&
            this.props.authentication.hasOwnProperty("authenticatedUser") &&
            (this.props.authentication.authenticatedUser.id === 52345 ||
              this.props.authentication.authenticatedUser.id == 90589) && (
              <CrewExport />
            )}

          <main>
            <div>{}</div>
            {this.props.crew.crew.length >= 0 && (
              <div className={this.props.classes.chipsWrapper}>
                {!this.props.crew.loadingCrew && (
                  <div>
                    {/* WEB VIEW */}
                    <Hidden smDown>
                      <div style={{ position: "relative" }}>
                        <Legend
                          open={this.state.showLegend}
                          close={() =>
                            this.setState({
                              showLegend: !this.state.showLegend,
                            })
                          }
                        />
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          <p
                            style={{
                              maxWidth: "800px",
                              textAlign: "left",
                              fontFamily: "roboto",
                              fontSize: "16px",
                            }}
                          >
                            <b style={{ fontWeight: "600" }}>{companyName}</b>{" "}
                            Production Crew Directory provides listings for
                            video, film, and production staff with easy search
                            features for local market locations, positions, &
                            owned equipment. For specific video & film crew
                            members{" "}
                            <b style={{ fontWeight: "600" }}>{companyName}</b>{" "}
                            provides Elite status based on vetting accuracy of
                            the listing, equipment quality, and successful shoot
                            bookings.
                          </p>
                          <div style={{ flexGrow: 1 }} />
                          {}
                          {/* </Hidden> */}

                          <Fab
                            color="primary"
                            className={this.props.classes.legendButton}
                            onClick={e =>
                              this.setState({
                                showLegend: !this.state.showLegend,
                              })
                            }
                          >
                            <HelpIcon style={{ color: "white" }} />
                            {/* <Icon>chrome_reader_mode</Icon> */}
                            {/* Legend */}
                          </Fab>
                        </div>
                      </div>
                    </Hidden>

                    {/* MOBILE VIEW */}
                    {accessLevel === 1 && (
                      <Hidden mdUp>
                        <Fab
                          color="primary"
                          className={this.props.classes.legendButton}
                          onClick={() =>
                            this.props.dispatch(
                              toggleCreateUserDialog(true, {})
                            )
                          }
                        >
                          <AddIcon style={{ color: "white" }} />
                        </Fab>
                      </Hidden>
                    )}

                    {/* WEB VIEW */}
                    <Hidden smDown>
                      <p
                        style={{
                          fontFamily: "roboto",
                          textAlign: "left",
                          fontSize: "16px",
                        }}
                      >
                        Use the search tools to find and book the crew for your
                        next shoot.
                      </p>
                      <div className={this.props.classes.resultsWrapper}>
                        <Typography
                          variant="h6"
                          className={this.props.classes.resultsNumber}
                        >
                          {this.props.crew.searchcrewLength}
                        </Typography>

                        <Typography
                          variant="subtitle1"
                          className={this.props.classes.resultsText}
                        >
                          Crew Matches
                        </Typography>
                      </div>
                    </Hidden>

                    {/* MOBILE VIEW */}
                    <Hidden mdUp>
                      <div className={this.props.classes.resultsWrapper}>
                        <Typography
                          variant="p"
                          style={{
                            fontSize: "1rem",
                            fontWeight: 600,
                          }}
                        >
                          {this.props.crew.searchcrewLength} Crew
                        </Typography>
                      </div>
                    </Hidden>

                    {this.state.selectedUser && (
                      <Chip
                        label={this.state.selectedUser.full_name}
                        className={this.props.classes.chip}
                        classes={{
                          deleteIcon: this.props.classes.chipDeleteIcon,
                        }}
                        deleteIcon={
                          <CancelIcon
                            onTouchEnd={() => this.onDelete("User")}
                          />
                        }
                        onDelete={() => this.onDelete("User")}
                      />
                    )}
                    {this.state.selectedRole && (
                      <Chip
                        label={this.state.selectedRole.name}
                        className={this.props.classes.chip}
                        classes={{
                          deleteIcon: this.props.classes.chipDeleteIcon,
                        }}
                        deleteIcon={
                          <CancelIcon
                            onTouchEnd={() => this.onDelete("Role")}
                          />
                        }
                        onDelete={() => this.onDelete("Role")}
                      />
                    )}
                    {this.state.selectedLocation && (
                      <Chip
                        label={this.state.selectedLocation.locations}
                        className={this.props.classes.chip}
                        classes={{
                          deleteIcon: this.props.classes.chipDeleteIcon,
                        }}
                        deleteIcon={
                          <CancelIcon
                            onTouchEnd={() => this.onDelete("Location")}
                          />
                        }
                        onDelete={() => this.onDelete("Location")}
                      />
                    )}
                    {this.state.selectedEquipment && (
                      <Chip
                        label={this.state.selectedEquipment.name}
                        className={this.props.classes.chip}
                        classes={{
                          deleteIcon: this.props.classes.chipDeleteIcon,
                        }}
                        deleteIcon={
                          <CancelIcon
                            onTouchEnd={() => this.onDelete("Equipment")}
                          />
                        }
                        onDelete={() => this.onDelete("Equipment")}
                      />
                    )}
                  </div>
                )}
              </div>
            )}
            <section className={this.props.classes.crewSection}>
              <div className={this.props.classes.contentWrapper}>
                <LoadingIndicator working={this.props.crew.loadingCrew}>
                  Loading Crew Members
                </LoadingIndicator>
                {this.props.crew.crew.length > 0 && (
                  <InfiniteScroll
                    next={this.fetchMoreItems}
                    hasMore={this.state.hasMoreItems}
                    dataLength={pagedCrew.length}
                    loader={
                      this.props.crew.searchcrewLength > 100 &&
                      this.props.crew.crew.length <
                        this.props.crew.searchcrewLength && <h4>Loading...</h4>
                    }
                  >
                    <div className={this.props.classes.crewSectionWrapper}>
                      {pagedCrew.map((crew, index) => {
                        const isMe =
                          this.props.authentication.authenticatedUser.id ===
                          crew.id

                        return (
                          <Fragment key={index}>
                            <div
                              data-id={crew.id}
                              className={this.props.classes.crewCardWrapper}
                            >
                              <CrewCard
                                crew={crew}
                                currentUser={
                                  this.props.authentication.authenticatedUser
                                }
                                accessLevel={this.props.accessLevel}
                                activeCompany={this.props.activeCompany}
                                onOpenProfile={() =>
                                  this.props.dispatch(
                                    toggleProfileDialog(true, { id: crew.id })
                                  )
                                }
                                onOpenBookingDialog={() => {
                                  // old booking dialog
                                  if (
                                    this.props.activeCompany ||
                                    getCurrentHost() === "crewmama"
                                  ) {
                                    const newCrew = {
                                      id: crew.id,
                                      first_name: crew.first_name,
                                      last_name: crew.last_name,
                                      profile_image: crew.profile_image,
                                    }
                                    if (this.state.selectedRole) {
                                      newCrew.shootRole = this.state.selectedRole
                                      newCrew.shootRole.client_rate =
                                        newCrew.shootRole.rate
                                      newCrew.shootRole.crew_rate =
                                        Number(newCrew.shootRole.client_rate) -
                                        Number(newCrew.shootRole.client_rate) *
                                          0.12
                                      newCrew.shootRole.percentage = 12
                                      delete newCrew.shootRole.rate
                                    } else {
                                      newCrew.shootRole = null
                                    }

                                    this.props.dispatch(
                                      toggleShootDialog({ open: true })
                                    )
                                    this.props.dispatch(
                                      setShootDialogCrew([newCrew])
                                    )
                                  } else {
                                    if (isMe) {
                                      this.props.dispatch(
                                        openSnackBar({
                                          message: "You can't book yourself",
                                        })
                                      )
                                    } else {
                                      this.props.dispatch(
                                        toggleBookingDialog(true, crew)
                                      )
                                    }
                                  }
                                }}
                                onOpenMessageDrawer={this.openMessageDrawer}
                                ratingChanged={val =>
                                  this.ratingChanged(val, crew)
                                }
                                isPositionSearch={
                                  this.state.selectedRole || false
                                }
                                onRemoveFromCompany={this.removeFromCompany}
                                history={this.props.history}
                              />
                            </div>
                            {(index + 1) % (adFrequency - 1) === 0 &&
                              this.state.ads &&
                              this.state.ads.length > 0 && (
                                <div
                                  className={this.props.classes.crewCardWrapper}
                                >
                                  <AdCard
                                    ad={this.state.ads[adIndex]}
                                    adIndex={index}
                                  />
                                  {(() => {
                                    // repeat ads once all are used
                                    if (adIndex < this.state.ads.length - 1) {
                                      adIndex++
                                    } else {
                                      adIndex = 0
                                    }
                                    return ""
                                  })()}
                                </div>
                              )}
                          </Fragment>
                        )
                      })}
                    </div>
                    {}
                  </InfiniteScroll>
                )}
              </div>
              {}
            </section>
          </main>
        </div>
        <CreateUserDialog onCreateUser={this.resetControls} />
      </Fragment>
    )
  }
}

const mapStateToProps = state => {
  return {
    authentication: state.authentication,
    crew: state.crew,
    users: state.misc.users,
    roles: state.misc.roles,
    locations: state.misc.locations,
    equipment: state.misc.equipment,
    activeCompany: state.companies.activeCompany,
    accessLevel: state.companies.accessLevel,
    crewlength: state.crewlength,
    searchcrewLength: state.searchcrewLength,
    crewModal: state.users.crewModal,
    setModal: state.users.setModal,
    childParentRoles: state.misc.childParentRoles,
  }
}

export default compose(
  connect(mapStateToProps),
  withStyles(styles),
  widthWidth()
)(Crew)
